import Settings from '@/components/settings/main';


const routes = [
    {
        path: '/settings',
        name: 'settings',
        component: Settings,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                
                { text: 'Settings' }
            ],
			requiresAuth: true
        }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/components/settings/routes/index.js